import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../components/CustomButtons/Button.js";
import CustomTable from "../../components/Table/Table";
import { getAllCriteria, deleteCriterion } from "../../api/apiCriteria.js";
import { isAuthenticated } from "../../utils/authService";
import { showQuestionToast } from "../../utils/toastMessages";
import { ToastContainer } from "react-toastify";

export default function ShowCriteria() {
  const history = useHistory(); // Initialize useHistory hook

  const [tableData, setTableData] = useState([]);
  const [tableHead, setTableHead] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const retData = await getAllCriteria();
        const { tableHead, tableData } = transformData(retData);
        setTableHead(tableHead);
        setTableData(tableData);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  function handleEditCriteria() {
    history.push("/admin/editcriteria");
  }

  function handleEdit(id) {
    if (isAuthenticated()) history.push(`/admin/editCriterion/${id}`);
  }

  async function handleDelete(id) {
    if (!isAuthenticated()) return;
  
    showQuestionToast({
      title: "Brisanje kriterijuma!",
      message: "Da li ste sigurni da želite da izbrišete kriterijum?",
      onConfirm: async () => {
        try {
          await deleteCriterion(id);
          setTableData((prevTableData) => {
            const newTableData = prevTableData.filter((row) => row.id !== id);
            return newTableData;
          });
        } catch (error) {
          console.error("Failed to delete criterion:", error);
        }
      },
      onCancel: () => {}
    });
  }
  

  const transformData = (data) => {
    const tableHead = [
      "Oznaka",
      "Naziv",
      "Tip",
      "Jedinica mjere",
      "Koeficijent",
      "Status",
      isAuthenticated() && "Izmjena/Brisanje",
    ];
    const tableData = data.map((row) => ({
      id: row.id, // Include id here, but do not display it in the table
      displayData: [
        row.oznaka,
        row.naziv,
        row.tip,
        row.jedinica_mjere,
        row.koeficijent.toString(),
        row.status ? "aktivan" : "neaktivan",
        isAuthenticated() && (
          <div key={row.id}>
            <Button color="primary" onPress={() => handleEdit(row.id)}>
              Izmjena
            </Button>
            <Button color="rose" onPress={() => handleDelete(row.id)}>
              Brisanje
            </Button>
          </div>
        ),
      ],
    }));

    return { tableHead, tableData };
  };

  return (
    <div>
      <CustomTable
        tableHeaderColor="info"
        tableHead={tableHead}
        tableData={tableData.map((row) => row.displayData)}
      />

      {isAuthenticated() && (
        <Button color="info" onPress={handleEditCriteria}>
          Izmjeni sve kriterijume
        </Button>
      )}

      <ToastContainer/>
    </div>
  );
}

